/* istanbul ignore file */
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {ImageModeId, ratioIdToRatioMap} from '../../../../types/galleryTypes';

export const promotionItemCustomCssVars = ({styleParams: styles}: CustomCssVarsFnParams) => {
  return {
    promoCardsImageModeFit: styles.numbers.gallery_promoCardsImageMode === ImageModeId.Fit ? 'contain' : 'cover',
    promoItemImageRatio: String(ratioIdToRatioMap[styles.numbers.galleryImageRatio]),
  };
};
